// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1mwbt","main":"Input_main__2R0vp","middle":"Input_middle__3Z_RZ","small":"Input_small__2EoZG"};